if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        const dataElement = document.getElementById(`VariantData-${this.dataset.section}`);
        if (!dataElement) return;

        try {
          this.variantData = JSON.parse(dataElement.textContent);
        } catch (e) {
          console.error("VariantSelects: Could not parse variant JSON data.", e);
          return;
        }

        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          if (!target) return;

          this.updateSelectedSwatchValue(event);
          this.updateAvailability();

          if (window.FoxTheme?.pubsub) {
            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
              data: {
                event,
                target,
                selectedOptionValues: this.selectedOptionValues,
              },
            });
          }
        });

        this.updateAvailability();
      }

      updateAvailability() {
        if (!this.variantData) return;

        const fieldsets = Array.from(this.querySelectorAll('fieldset, .select'));
        const selectedOptions = Array.from(this.querySelectorAll('fieldset input:checked, select')).map(el => el.value);

        fieldsets.forEach((fieldset, index) => {
          const inputs = fieldset.querySelectorAll('input[type="radio"], option');
          
          inputs.forEach(input => {
            if (!input.value) return;

            const testOptions = [...selectedOptions];
            testOptions[index] = input.value;

            const isAvailable = this.variantData.some(variant => {
              return variant.options.every((opt, i) => opt === testOptions[i]) && variant.available;
            });

            // TARGET LABELS (FOR SWATCHES)
            const label = this.querySelector(`label[for="${input.id}"]`);
            if (label) {
              if (isAvailable) {
                label.classList.remove('is-sold-out', 'disabled', 'is-unavailable');
                label.style.opacity = "1";
              } else {
                // Applying all three classes ensures the theme's CSS finds it
                label.classList.add('is-sold-out', 'disabled', 'is-unavailable');
                label.style.opacity = "0.7"; // Keep it visible enough to see the cross line
              }
            } 
            
            // TARGET DROPDOWNS
            if (input.tagName === 'OPTION') {
              input.disabled = !isAvailable;
            }
          });
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;
        const container = target.closest('.product-form__input');
        if (!container) return;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options).forEach(opt => opt.removeAttribute('selected'));
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedSwatchDisplay = container.querySelector('[data-selected-value] > .swatch');
          
          if (selectedSwatchDisplay) {
            selectedSwatchDisplay.style.setProperty('--swatch--background', swatchValue || 'unset');
            swatchValue ? selectedSwatchDisplay.classList.remove('swatch--unavailable') : selectedSwatchDisplay.classList.add('swatch--unavailable');
          }
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedTextDisplay = container.querySelector('[data-selected-swatch-value]');
          if (selectedTextDisplay) selectedTextDisplay.innerHTML = value;
        }
      }
    }
  );
}